import { render, staticRenderFns } from "./Prior.vue?vue&type=template&id=caca4464&"
import script from "./Prior.vue?vue&type=script&lang=js&"
export * from "./Prior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports